













import {Vue,Component,Prop, Watch,Mixins} from 'vue-property-decorator';
import BookmarkMixin from './BookmarkMixin';
@Component
export default  class  CurrencyBookmark extends Mixins(BookmarkMixin){
    amount = '';
    created(){
        this.value = 0;
    }
    @Watch('amount')
    onAmountChanged(newVal: string, oldVal: string){
         if(!newVal)return;
        // const array = newVal.split('');
        // if(array.length == 0)return;
        // if(isNaN(parseInt(array[array.length -1]))){
        //      this.amount = (this.amount as string).substring(0,this.amount.length -1);
        // }
        // this.amount = this.amount.replace(',','');
        const amountStr = this.replaceNanChars(this.amount);

        this.amount = this.formatMoney(amountStr);
    }

    replaceNanChars(amount: any){
        amount =  amount.replaceAll('٬','');
        amount =  amount.replaceAll('۱','1');
        amount =  amount.replaceAll('۲','2');
        amount =  amount.replaceAll('۳','3');
        amount =  amount.replaceAll('۴','4');
        amount =  amount.replaceAll('۵','5');
        amount =  amount.replaceAll('۶','6');
        amount =  amount.replaceAll('۷','7');
        amount =  amount.replaceAll('۸','8');
        amount =  amount.replaceAll('۹','9');
        amount =  amount.replaceAll('۰','0');
        amount = amount.replace('ریال','');
        amount = amount.replace(' ','');
        amount = amount.replace('‎ ','');
        return amount;
    }
    formatMoney(amount: string) {
        
       
        
        //const j = (amount.length > 3) ? amount.length % 3 : 0;
        // const result =   (j ? amount.substr(0, j) + "," : '') + amount.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + ",");
        //const result =   (j ? amount.substr(0, j) + "," : '') + amount.substr(j).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        
        const formatter = new Intl.NumberFormat('fa-IR', {
        style: 'currency',
        currency: 'IRR',


        });
        if(isNaN(parseInt(amount)))
            return formatter.format(0);
        const result = formatter.format(parseInt(amount));
        return result;
    }
    focusOut(){
        // this.value = this.amount;
        const result= this.replaceNanChars(this.amount); //this.amount.replace(/,/g,'')
        this.value = parseInt(result);
        // this.value = parseInt(this.amount.replace(/(\d)(?=(\d{3})+(?!\d))/g,""));
        this.$emit("value-changed",this.englishName);
    }
    onValueChanged(){
        this.amount = this.formatMoney((this.value as number).toString());
    }
}
